import { useState } from 'react';
import { useDataTable, useDialogCrup, ToastService } from '@iamsoftware/react-hooks';
import { SentMailHistoryService as Service } from './SentMailHistoryService';
import { MailInformationHTML } from './MailInformationHTML';


export const HistorySentMail = () => {
  const dataKey = 'emailMessageId';
  const header = 'Lịch sử gửi mail';

  const [display, setDisplay] = useState(null)

  const { render: renderDataTable, reloadLazyData } = useDataTable({
    tableHeader: header,
    dataKey,
    columns: [
      { field: 'emailTypeEnum', header: 'Loại email', matchMode: 'contains', minWidth: 150 },
      { field: 'toPseudoId', header: 'Mã khách hàng', matchMode: 'contains', minWidth: 150 },
      { field: 'toPartyName', header: 'Tên khách hàng', matchMode: 'contains', minWidth: 150 },
      { field: 'toAddresses', header: 'Email nhận', matchMode: 'contains', minWidth: 150 },
      { field: 'subject', header: 'Tiêu đề', matchMode: 'contains', minWidth: 150 },
      { field: 'status', header: 'Trạng thái', matchMode: 'contains', minWidth: 150 },
      { field: 'sentDate', header: 'Ngày gửi', minWidth: 150, dataType: 'date-time' },
      { field: 'fromAddress', header: 'Email gửi', matchMode: 'contains', minWidth: 150 },
      // {field:'fromName', header:'Người gửi', matchMode:'contains', minWidth:150},
    ],
    indexColumnWidth: 45,
    actionColumnWidth: 90,
    initActions(items: Array<any>) {
      if (items) {
        items.forEach(item => {
          item.actions = [
            { icon: 'pi pi-send', title: 'Gửi lại email', className: 'p-button-secondary', command: () => update(item) },
            { icon: 'pi pi-eye', title: 'Nội dung', className: 'p-button-info', command: () => doReview(item) },
          ]
        })
      }
    },
    getList(lazyLoadEvent: any): Promise<any> {
      return Service.getList(lazyLoadEvent).then()
    },
    originalProps: { scrollHeight: 'calc(100vh - 300px)' }
  })

  const { render: renderDialogCrup, update } = useDialogCrup({
    header: '!Gửi lại email',
    dataKey,
    fields: [
      {
        field: 'toAddresses',
        header: 'Địa chỉ email',
        required: true,
        className: 'md:col-12',
        labelClassName: 'text-color font-medium'
      },
      {
        type: 'custom',
        body: <i style={{ color: 'var(--text-color-secondary)' }}>(Mỗi email cách nhau bởi dấu ,)</i>
      }
    ],
    width: '40rem',
    submitLabel: 'Gửi',
    updateItem(id: string, item: any): Promise<any> {
      return Service.resend(id, item).then((res) => {
        ToastService.success('Đã gửi lại email thành công');
        reloadLazyData();
        return res;
      }).catch(err => {
        ToastService.error('Có lỗi khi gửi lại email: ' + (err?.message || 'Unknown error'));
        throw err;
      })
    }
  })

  const doReview = (item) => {
    if (item[dataKey]) {
      Service.review(item[dataKey]).then(data => {
        setDisplay(data);
      })
    }
  }

  // const doResend = (item) => {
  //   if (item[dataKey]){
  //     ConfirmDialogService.confirm('Xác nhận gửi lại email','Bạn có muốn gửi lại email này?',() =>{
  //       Service.resend(item[dataKey]).then(() =>{
  //         ToastService.success();
  //         reloadLazyData()
  //       })
  //     })
  //   }
  // }

  return (
    <div className="card border-none shadow-1 border-round-xl" style={{ backgroundColor: 'var(--surface-ground)' }}>
      <style dangerouslySetInnerHTML={{
        __html: `
        .lich-su-gui-mail-table .p-datatable-thead > tr:first-child > th {
          position: sticky !important; top: 0 !important; z-index: 10 !important;
          background: var(--surface-card) !important;
        }
        .lich-su-gui-mail-table .p-datatable-thead > tr:nth-child(2) > th {
          position: sticky !important; top: 38px !important; z-index: 9 !important;
          background: var(--surface-card) !important;
        }
      `}} />
      <div className="col-12">
        <h3 className="m-0 mb-4" style={{ color: 'var(--text-color)', fontWeight: 'bold' }}>Lịch sử gửi mail</h3>
      </div>
      <div className="col-12 py-0 lich-su-gui-mail-table">
        {renderDataTable()}
      </div>
      {renderDialogCrup()}
      <MailInformationHTML display={display} setDisplay={setDisplay} />
    </div>
  )
}